import React  from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";


export default function FieldTaskStatus_ViewSmall(props:FieldViewSmallProps) {

    const value = _.get(props.model, props.field.fieldId, null)


    const status = gd.session.statuses.get(value)
    if (!status) return false;

    return (
        <div className={Classes('ui5-status-list', 'status-c{0}'.f(status.color), props.className)}>
            {status.name}
        </div>
    );

}
